import React from 'react';

import './styles.css';

export default props => {
  return (
    <div
      className={`Image Image--${props.type}`}
      style={{ height: `${props.height}px` }}
    />
  );
};
